var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcomplyLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 47,
    viewBox: "0 0 178 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2508 19.7542L23.2121 0.715437C22.755 0.258349 22.139 0 21.4831 0C20.8273 0 20.2112 0.258349 19.7542 0.715437L0.715442 19.7542C-0.238481 20.7081 -0.238481 22.2582 0.715442 23.2121C1.66937 24.166 3.23936 24.166 4.19329 23.2121L5.60429 21.821V37.9184C5.60429 39.2698 6.67746 40.3032 8.02885 40.3032H34.9573C36.3087 40.3032 37.4017 39.2698 37.4017 37.9184V21.821L38.7929 23.2121C39.2698 23.6891 39.9058 23.9276 40.5219 23.9276C41.1379 23.9276 41.7739 23.6891 42.2508 23.2121C43.2048 22.2582 43.2048 20.7081 42.2508 19.7542ZM32.4135 35.5336H10.5528V20.0324H32.4135V35.5336ZM12.2818 15.064L21.4831 5.86265L30.6845 15.064H12.2818Z",
    fill: "#60C3AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9984 36.5653C59.8982 36.5653 57.4736 35.0351 57.4736 31.0405V19.9512H58.9244C62.2433 19.9512 63.3164 20.9051 63.3164 23.9855V30.1661C63.3164 31.6765 64.0319 32.1336 65.6416 32.1336H66.357V33.8625C66.357 35.8896 64.8268 36.5653 62.9984 36.5653Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2032 21.8397C83.1301 20.4485 80.4869 19.6536 78.1419 19.6536C74.7038 19.6536 72.1798 21.9192 72.1798 25.3771C72.1798 29.7095 74.823 31.7764 78.2611 31.7764C80.5267 31.7764 83.0506 30.9218 84.1039 29.8089H84.2629V31.995C84.2629 34.7375 81.5203 36.8242 77.3867 36.8242C71.5836 36.8242 66.3569 32.6508 66.3569 25.9535C66.3569 19.7728 70.6893 14.6455 77.7643 14.6455C81.9178 14.6455 84.3622 16.7123 84.3622 19.6933V21.8794H84.2032V21.8397Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0013 18.958C98.612 18.958 102.765 22.4557 102.765 27.6824C102.765 33.2072 99.4069 36.7844 93.584 36.7844C88.7548 36.7844 84.8198 33.2271 84.8198 28.2389C84.8198 22.6346 88.6951 18.958 94.0013 18.958ZM93.6436 23.5686C92.0537 23.5686 90.603 25.2579 90.603 27.5632C90.603 30.8224 91.8948 32.2334 93.9616 32.2334C95.8098 32.2334 97.0022 30.5442 97.0022 28.1991C96.9823 25.1585 95.6707 23.5686 93.6436 23.5686Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.541 36.3069C125.441 36.3069 124.725 34.9953 124.725 32.8887V26.6484C124.725 24.4623 123.99 23.6674 122.301 23.6674C120.671 23.6674 120.115 24.8598 120.115 26.5491V36.287H118.088C115.723 36.287 114.471 35.512 114.471 32.8688V26.4696C114.471 24.4822 113.696 23.6475 112.165 23.6475C110.536 23.6475 109.9 24.4822 109.9 26.5689V36.2671H107.873C105.269 36.2671 104.057 35.0151 104.057 32.8489V26.9267C104.057 22.0179 106.879 18.8779 112.265 18.8779C114.908 18.8779 116.895 20.5075 117.452 21.8788C118.247 20.587 120.314 18.8779 122.738 18.8779C127.647 18.8779 130.568 21.7993 130.568 27.0856V36.2671H128.541V36.3069Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 36.804C139.968 36.804 138.636 35.7507 137.901 34.4987V41.5339H135.775C133.449 41.5339 132.217 40.3017 132.217 37.44V28.4969C132.217 22.4356 135.576 18.918 141.558 18.918C146.506 18.918 150.223 22.2567 150.223 27.4834C150.223 33.2666 146.844 36.804 142.233 36.804ZM140.882 23.3696C139.292 23.3696 138 24.8999 138 27.4039C138 31.001 139.531 32.253 141.538 32.253C143.386 32.253 144.4 30.6234 144.4 28.0995C144.38 24.4825 143.287 23.3696 140.882 23.3696Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.437 36.5658C154.337 36.5658 151.654 34.7176 151.654 30.723V13.5723H153.721C156.264 13.5723 157.497 14.7448 157.497 17.6066V29.8684C157.497 31.3788 158.331 31.8359 159.961 31.8359H161.253V33.863C161.253 35.91 159.285 36.5658 157.437 36.5658Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.793 31.8568C169.063 40.9588 167.871 41.873 164.333 41.873C162.465 41.873 160.895 40.8594 160.895 38.9516V37.5405L163.419 37.3617C164.95 37.2425 165.665 36.6264 166.281 35.2352C163.857 31.6183 160.756 23.9273 160.081 19.416H163.121C164.572 19.416 166.062 20.3103 166.4 21.8207C166.977 24.4837 168.149 27.743 169.043 29.8098C170.295 27.266 171.627 22.715 171.985 19.4359H174.787C176.476 19.4359 177.271 20.2308 177.271 21.5822C177.251 23.3509 175.661 28.2597 173.793 31.8568Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.3819 20.8076H32.4136V26.9684H37.3819V20.8076Z",
    fill: "url(#paint0_linear)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6437 35.5137H20.2905V40.2833H27.6437V35.5137Z",
    fill: "url(#paint1_linear)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4044 36.1487C46.4044 42.1306 41.5553 46.9996 35.5535 46.9996C29.5716 46.9996 24.7026 42.1505 24.7026 36.1487C24.7026 30.1668 29.5517 25.2979 35.5535 25.2979C41.5553 25.2979 46.4044 30.1668 46.4044 36.1487Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.5141 43.3631C35.0172 43.3631 34.5602 43.1644 34.2024 42.8265L29.3335 37.9575C28.618 37.2421 28.618 36.0695 29.3335 35.3342C30.0489 34.6188 31.2214 34.6188 31.9567 35.3342L35.5141 38.8916L44.2782 30.1274C44.9937 29.412 46.1662 29.412 46.9015 30.1274C47.617 30.8428 47.617 32.0154 46.9015 32.7507L36.8257 42.8265C36.468 43.1842 35.991 43.3631 35.5141 43.3631Z",
    fill: "url(#paint2_linear)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3544 41.8133C34.8576 41.8133 34.4005 41.6145 34.0428 41.2767L29.1738 36.4077C28.4583 35.6923 28.4583 34.5197 29.1738 33.7844C29.8892 33.069 31.0618 33.069 31.7971 33.7844L35.3544 37.3418L44.1186 28.5776C44.834 27.8622 46.0065 27.8622 46.7419 28.5776C47.4573 29.293 47.4573 30.4656 46.7419 31.2009L36.6661 41.2767C36.3282 41.6145 35.8512 41.8133 35.3544 41.8133Z",
    fill: "#60C3AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2366 18.4615C58.5474 18.4615 57.1562 17.1698 57.1562 15.5799C57.1562 13.99 58.5474 12.6982 60.2366 12.6982C61.9259 12.6982 63.2773 13.99 63.2773 15.5799C63.2773 17.1698 61.9259 18.4615 60.2366 18.4615Z",
    fill: "#60C3AD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 34.8977,
    y1: 20.8129,
    x2: 34.8977,
    y2: 26.9737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20.2905,
    y1: 37.9038,
    x2: 27.6437,
    y2: 37.9038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 42.1199,
    y1: 30.035,
    x2: 33.8323,
    y2: 38.3226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B8BA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcomplyLogoLight);
export default __webpack_public_path__ + "static/media/icomply-logo-light.f21cd0f9.svg";
export { ForwardRef as ReactComponent };